import _ from 'underscore';
import GenericView from 'js/views/generic.view';
import NotificationModel from 'js/models/notification.model';
import NotificationRowView from 'js/views/notification.row.view';
import Template from 'js/templates/notifications.hbs';
import i18n from 'l10n';
import {debounce, el, memoize, tagName, template} from "../adapters/backbone-decorators";

require('metroHint2');

const gutterSize = 5;

@el("#notificationList")
@tagName("span")
@template(Template)
class NotificationsView extends GenericView {
    cachedModels = {};
    listviewViewport = '#notifications';
    listview = '#list-view';
    rowHeight = 80 + gutterSize;

    constructor(numberOfElements) {
        super();
        this.render(numberOfElements)
    }

    render(cap) {
        var templateOutput = this.template(cap !== undefined ? {fromDashboard: true} : {});
        this.$el.html(templateOutput);
        this.$('[data-i18n]').i18n();
        this.$('[data-i18n]').each(function () {
            if (typeof $(this).data("hint") === "string") {
                $.Metro.initAll(this);
            }
        });
        if (cap === undefined) {
            $(this.listview).on('scroll', () => this.redrawNotifications());
        }
        this.redrawNotifications(cap);
    }

    renderRest(){
        if (!_.isEmpty(this.cachedModels)) {
            $("#noNotifications").hide();
        }
    }

    addOne(item, el) {
        var title = item.get("title");
        if (!title || title === "") {
            if (["birthday", "nameday"].includes(item.get("templateSubType"))) {
                title = i18n.t("survey.noname" + item.get("templateSubType"));
            } else if (["birthday", "nameday", "BULK"].includes(item.get("campaignTemplateType"))) {
                title = i18n.t("survey.noname" + item.get("campaignTemplateType"));
            } else if (item.get("campaignTemplateType") === "TELLODY_VOUCHER" && item.get("templateSubType") === "") {
                title = i18n.t("voucher.nonameservice");
            } else if (item.get("campaignTemplateType") === "TELLODY_VOUCHER" && item.get("templateSubType") === "points") {
                title = i18n.t("voucher.points");
            } else if (item.get("sms") !== undefined) {
                title = i18n.t("survey.nonameSMS_EVENT");
            } else if (item.get("emails") !== undefined) {
                title = i18n.t("survey.nonameEMAIL_EVENT");
            } else {
                title = i18n.t("survey.noname" + item.get("templateSubType"));
            }
        }
        if (title.length > 1000) {
            title = title.substring(0, 1000) + '…';
        }
        if (["DaysLeft", "CreditsAvailable", "EmailAvailable"].includes(item.get("jsonClass"))) {
            item.set("date", new Date()); // Because date coming from server is local but interpreted as utc so in ui it gains 3 hours.
        }
        item.set({title: title});
        var view = new NotificationRowView({model: item, el: el});
        view.render();
    }

    @memoize
    getNotificationCount(data) {
        const url = '/CampaignCloud/Notifications/count';
        return $.ajaxDefaultQ({
            url,
            data,
            type: 'get'
        });
    }

    @debounce(200)
    async redrawNotifications(numberOfElements, visibleElements) {
            const notificationCount = await this.getNotificationCount();
            this.notificationCount = notificationCount;

            if (numberOfElements === undefined) {
                if (notificationCount) {
                    this.rowHeight = 80;
                    const totalHeight = (notificationCount * this.rowHeight);
                    const $scroller = this.$el.find(this.listview);
                    if ($scroller.length > 0) {
                        $scroller.find(".inner-container").height(totalHeight);
                        const scrollTop = $scroller.scrollTop();
                        // -200 because of header (navbar, title)
                        //const normalizedScrollTop = scrollTop <= 0 ? 0 : scrollTop;
                        const scrollTopElement = Math.floor(scrollTop / this.rowHeight);

                        const heightOfVisibleContacts = this.rowHeight * 10;
                        const listViewHeight = location.href.indexOf('NotificationCenter.htm') > -1 ? this.$el.find(this.listviewViewport).height() : heightOfVisibleContacts;
                        //const visibleElements = Math.ceil(listViewHeight / this.rowHeight);
                        // +1 because two notifications may be shown each by a part.
                        if(!visibleElements) visibleElements =  Math.ceil($scroller.height() / this.rowHeight);
                        this.renderOnDemand(scrollTopElement, visibleElements, notificationCount);
                    }
                }
            } else {
                this.renderOnDemand(0, numberOfElements, notificationCount, true);
            }
        }

    @debounce(100)
    async renderOnDemand(start, visibleElements, upperBound, fromDashboard, queryParams) {
        const range = _.range(start, Math.min(start + visibleElements, upperBound));
        const rangeToFetch = _.filter(range, k => !_.has(this.cachedModels, k));
        const leftBound = _.first(rangeToFetch);
        const rightBound = _.last(rangeToFetch);
        const count = rightBound - leftBound + 1;
        const $container = this.$el.find(this.listview);
        if (count > 0) {
            const url = `/CampaignCloud/Notifications?from=${leftBound}&count=${count}`;
            try {
                const response = await $.ajaxDefaultQ({
                    url,
                    data: _.extend({}, queryParams, {from: leftBound, count}),
                    type: 'get',
                    dataType: 'json'
                });
                if (response && response.length > 0) {
                    const newModels = _.map(response, model => new NotificationModel(model, {parse: true}));
                    const indexedModels = _.object(rangeToFetch, newModels);
                    _.extend(this.cachedModels, indexedModels);
                }
            } catch (e) {
                console.log(e);
            }
        }
        const viewport = $container.find(".viewport");
        viewport.empty();
        if (!fromDashboard) viewport.css("margin-top", start * this.rowHeight);
        _.chain(this.cachedModels).pick(range).each(model => {
            const el = fromDashboard ?
                $('<div class="fg-darker balloon" style="margin-bottom: 17px;"></div>')
                : $(`<div class="fg-darker balloon"></div>`);
            this.$el.find(this.listview).find(".inner-container").find(".viewport").append(el);
            this.addOne(model, el);
        });
        this.renderRest();
    }
}

export default NotificationsView;